var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffde00;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2{fill:#ffc12e;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#f4f3ef;stroke-miterlimit:10;stroke-width:0.75px;}.cls-3{fill:#ff9600;}.cls-4{fill:#ffc55c;}.cls-5{fill:#d8300f;}.cls-6{fill:#e7a900;}.cls-7{fill:#ffd245;}.cls-8{fill:#ffb52e;}.cls-9{fill:#e5c923;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "themeLogos"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.76 30.54 23.86 22.25 32.35 19.26 40.04 22.85 43.2 31.38 39.85 39.86 31.5 43.37 22.75 39.39 19.76 30.54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,22.85A15.71,15.71,0,0,0,37.18,18c-.88,1.65-1.22.44-4.83,1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.2,31.37a15.79,15.79,0,0,0,1.48-5.46c-1.8.53-1.56-1.18-4.7-3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.85,39.86A15.39,15.39,0,0,0,44.8,37.1c-1.63-.91-.72-2.35-1.49-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.31,43.29a14.66,14.66,0,0,0,5.33,1.48C36.16,43,38,43,40,39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.75,39.39a15.47,15.47,0,0,0,2.78,4.93c.9-1.63,2.34-.16,6-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.76,30.54A15.5,15.5,0,0,0,18,35.92c1.82-.43,1.9,1.48,4.93,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24,22.08a16.52,16.52,0,0,0-5.22,2.67c1.58,1,.32,2.29.9,5.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.67,19.41a15.51,15.51,0,0,0-5.34-1.89c.39,1.83-1.25,1.76-3.47,4.73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a15cab637f0f05ddd4121d7078300425.svg";
export { ForwardRef as ReactComponent };